import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchCountries'
})
export class SearchCountriesPipe implements PipeTransform {

  transform(countries: any[], filter: string): any {
    if (!countries || !filter) {
        return countries;
    }
  
    return countries.filter(item => item.toLocaleLowerCase().includes(filter.toLocaleLowerCase()));
}

}
